import { RaThemeOptions, defaultTheme } from 'react-admin';

export const myTheme: RaThemeOptions = {
  ...defaultTheme,
  palette: {
    mode: 'light',
    primary: {
      light: '#337597',
      main: '#00537e',
      dark: '003a58',
      contrastText: '#fff',
    },
    secondary: {
      light: '#aaaaaf',
      main: '#fffff',
      dark: '#f5f5fb',
      contrastText: '#fff'
    },
    error: {
      light: '#c83333',
      main: '#bb0000',
      dark: '#820000',
      contrastText: '#fff'
    },
    success: {
      main: '#a4c74b'
    },
    background: {
      paper: '#ffffff',
      default: '#f3f3fa'
    },
    text: {

    }
  },
  components: {
    ...defaultTheme.components,
    MuiAppBar: {
      defaultProps: {
        sx: {color: '#777777', py: '1px'},
        elevation: 0
      }
    }
  }

}